<template>
  <v-container fluid>
    <page-title icon="fas fa-fw fa-map">
      Territories
    </page-title>

    <v-card>
      <v-data-table :headers="headers"
                    :items="territories"
                    :loading="busy"
                    :items-per-page="-1"
                    :footer-props="footerProps"
                    fixed-header
                    hide-default-footer
                    dense>
        <template v-slot:item.actions="{item: territory}">
          <v-btn :to="{name: 'admin.territory.edit', params: {territoryID: territory.id}}"
                 x-small>
            Edit
          </v-btn>
        </template>
      </v-data-table>
      <v-card-actions>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {orderBy} from 'lodash';
import territoryService from '../../services/territoryService';
import PageTitle from '../../components/PageTitle.vue';

export default {
  components: {PageTitle},
  data() {
    return {
      busy: false,
      territories: [],
    }
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ]),
    footerProps() {
      return {
        'disable-items-per-page': true,
        'disable-pagination': true,
      }
    },
    headers() {
      return [
        {
          value: 'actions',
        },
        {
          text: 'Salesforce Name',
          value: 'salesforce_name',
        },
        {
          text: 'Type',
          value: 'territory_type',
        },
        {
          text: 'Region ID',
          value: 'region_id',
        },
        {
          text: 'Region Name',
          value: 'region_name',
        },
        {
          text: 'District ID',
          value: 'district_id',
        },
        {
          text: 'District Name',
          value: 'district_name',
        },
        /*{
          text: 'Territory ID',
          value: 'territory_id',
        },*/
        {
          text: 'Territory External ID',
          value: 'territory_external_id',
        },
        {
          text: 'Territory Code',
          value: 'territory_code',
        },
        {
          text: 'Territory Name',
          value: 'territory_name',
        },
        {
          text: 'Active Users',
          value: 'active_users_count',
        }
      ];
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.busy = true;
      territoryService.getTerritories()
        .then(data => {
          this.territories = orderBy(data, ['salesforce_name', 'region_name', 'district_name', 'territory_name'], ['asc', 'asc', 'asc', 'asc']);
        })
        .finally(() => {
          this.busy = false;
        })
    }
  }
}
</script>
